/**
 * Converts a latitude/longitude object to an array [longitude, latitude]
 * with comprehensive validation to prevent NaN values
 * 
 * @param {Object} latLong - Object with lat and long properties
 * @param {number} latLong.lat - Latitude (-90 to 90)
 * @param {number} latLong.long - Longitude (-180 to 180)
 * @returns {Array<number>|null} [longitude, latitude] or null if invalid
 */
export const convertLatLongToArray = latLong => {
  // Check if object exists
  if (!latLong) return null;
  
  // Extract values
  const { long, lat } = latLong;
  
  // Validate that both are numbers (not undefined, null, or other types)
  if (typeof long !== 'number' || typeof lat !== 'number') {
    return null;
  }
  
  // Check for NaN values
  if (Number.isNaN(long) || Number.isNaN(lat)) {
    return null;
  }
  
  // Check for zero coordinates (likely invalid or placeholder)
  if (long === 0 && lat === 0) {
    return null;
  }
  
  // Validate coordinate ranges (Longitude: -180 to 180, Latitude: -90 to 90)
  if (long < -180 || long > 180 ) {
    return null;
  }

  if (lat < -90 || lat > 90) {
    return null;
  }

  return [long, lat];
};

export default {};
